import { type User } from "@prisma/client";
import { useLocation } from "@remix-run/react";

import { Avatar } from "../Avatar";
import { HomeFilters } from "../HomeFilters/HomeFilters";
import { NavLink } from "../NavLink";

import { LogoOrBackButton } from "./LogoOrBackButton";

interface Props {
  user?: User;
  showBorder?: boolean;
  matchCount?: number;
}

export function Navbar({ user, matchCount, showBorder = true }: Props) {
  const location = useLocation();

  const isHome = location.pathname === "/";
  return (
    <div className="sticky top-0 bg-black">
      <div className="flex justify-between items-center w-full p-4">
        <LogoOrBackButton matchCount={matchCount} />
        {user ? (
          <div className="flex gap-4 items-center">
            {isHome ? <HomeFilters /> : null}

            <NavLink
              aria-label="My Profile"
              to={`/${user.username}`}
              prefetch="intent"
              className="rounded-full focus-visible:outline-none focus-visible:ring focus-visible:ring-white/80"
            >
              <Avatar imageUrl={user.pfpUrl} name={user.username} />
            </NavLink>
          </div>
        ) : null}
      </div>
      {showBorder ? <hr className="border-gray-800" /> : null}
    </div>
  );
}
